const tiers = ["1", "2", "3", "4"];

export function TierFilter({ selected, onChange, label }: { selected: Set<string>; onChange: (tiers: Set<string>) => void; label: string }) {
  const toggle = (tier: string) => {
    const next = new Set(selected);
    if (next.has(tier)) next.delete(tier); else next.add(tier);
    onChange(next);
  };
  return <div className="tier-filter" role="group" aria-label={label}>
    <span>Tier</span>
    {tiers.map((tier) => <button key={tier} type="button" className={selected.has(tier) ? "active" : ""} aria-pressed={selected.has(tier)} onClick={() => toggle(tier)}>{tier}</button>)}
    {selected.size > 0 && <button type="button" onClick={() => onChange(new Set())}>All</button>}
  </div>;
}
